module.exports = __webpack_public_path__ + "media/images/samples/infographics/info-1-b23037e6b72e72f13af8e1107cd6c5d4.jpg";